function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
 }

/*Handle share modal button text assignment and copy functionality*/
document.addEventListener("DOMContentLoaded", function (){
  $(".share-link-item").on('click', function(){
    setButtonText();
  });

  function setButtonText() {
    let modalHeader = $(".modal-header h5").text().trim().toLowerCase();
    console.log(modalHeader);
    let modalButton = $("#share-copy");
    switch (modalHeader) {
      case 'custom graph link':
      case 'page short url':
        $(modalButton).text('Copy Graph Link');
        break;
      case 'graph image link':
      case 'image short url':
        $(modalButton).text('Copy Image Link');
        break;
      case 'embed in website':
        $(modalButton).text('Copy Embed Code');
        break;
    }
  }

  $("#share-copy").on('click', function(){
    $(".copy-to-clipboard").click();
  });
  /*end share modal handling*/


  function focusShareLinks(){
    setTimeout(()=>{
          $('#share-links-btn').focus();
        }, 1000
    )
  }

  // ensure that graph/map div background color always matches graph/map frame color
  setTimeout(()=>{
        function updateGraphBackgroundColor() {
        let computedStyle = window.getComputedStyle($('.graph-footer').get(0));
        let backgroundColor = computedStyle.backgroundColor;
        $('#zoom-and-share').get(0).style.backgroundColor = backgroundColor;
      }

      updateGraphBackgroundColor();
      let graphBgObserver = new MutationObserver(updateGraphBackgroundColor);
      graphBgObserver.observe($('.graph-footer').get(0), {
        attributes: true,
        attributeFilter: ['style'],
        childList: true,
        subtree: true
      });
    }, 1500
  );
});

const browserArray = ['Chrome', 'Firefox', 'Safari', 'Edg', 'EdgA', 'EdgiOS', 'OPR'];

// load related data and content images only after their window appears on screen (only if user agent is a "browser")
document.addEventListener("DOMContentLoaded", function() {
  if(browserArray.includes(navigator.userAgent.split(' ').lastItem.split('/')[0])) {
    let lazyloadImages = document.querySelectorAll("div.trending-series-item img.lazy-load, #related-resource-container img.lazy-load");

    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(async function(entry) {
          if (entry.isIntersecting) {
            let img = entry.target;
            $(img).attr("src",$(img).data("src")).fadeIn();
            img.classList.remove('lazy-load');
            lazyImageObserver.unobserve(img);
            // wait before loading the next image or server
            // will respond with 404s after too many requests
            await sleep(700);
          }
        });
      });

      lazyloadImages.forEach(function(lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    }
  }
});

// 508 fix for footer tab order
document.addEventListener("DOMContentLoaded", function() {
  $('body').on('keydown', '#recessionLink', function(e) {
    if(e.shiftKey && e.keyCode == 9 && isMap == false ) { 
      return;
    }
    if (e.which == 9) {
      e.preventDefault();
      $('#fullscreen-btn-508').focus();
    }
  });
});

// 508 fix for footer tab order
document.addEventListener("DOMContentLoaded", function() {
  $('body').on('keydown', '#fullscreen-btn-508', function(e) {

    if(e.shiftKey && e.keyCode == 9 && isMap == false) { 
      e.preventDefault();
      $('#recessionLink').focus();
    }
    if (e.which == 9) {
      return;
    }
  });
});

// 508 tab order for end of edit line panel
document.addEventListener("DOMContentLoaded", function() {
  $('body').on('keydown', '#formula-units-input', function(e) {
    if ($('.fg-min-max-avg-gtm:visible').length === 0 && !e.shiftKey && e.keyCode == 9) {
      e.preventDefault();
      $('#overlay-tabs .active').focus();
    }
  });
  $('body').on('keydown', '.fg-min-max-avg-gtm', function(e) {
    if(!e.shiftKey && e.keyCode == 9 && $($(".mma-collapse:visible").get(0).parentElement.nextSibling).hasClass("hide")) {
      e.preventDefault();
      $('#overlay-tabs .active').focus();
    }
  });

  var tabObserver = new MutationObserver(function(mutations) {
    $(".mma-options").find("input").unbind();
    $(".mma-options").find("input").on('keydown', function(e) {
      if(!e.shiftKey && e.keyCode == 9) {
        e.preventDefault();
        $('#overlay-tabs .active').focus();
      }
    });
    $('.edit-series-tab').focus();
  });

  tabObserver.observe(document.querySelector(".tab-content"), {
      childList: true
  });
});

// 508 tab order for end of add line panel
document.addEventListener("DOMContentLoaded", function() {
  $('.collapse-user-defined-line').on('keydown', function(e) {
    if ($('.user-line-show').length == 0 && !e.shiftKey && e.keyCode == 9) {
      e.preventDefault();
      $('#overlay-tabs .active').focus();
    }
  });
  $('#add-trend-line-btn').on('keydown', function(e) {
    if(!e.shiftKey && e.keyCode == 9) {
      e.preventDefault();
      $('#overlay-tabs .active').focus();
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  // 508 tab order for edit tabs
  $("#overlay-tabs .nav-link, .overlay-panel-close").on('keydown', function(e) {
    switch (e.key) {
      case "Tab":
        e.preventDefault();
        if(e.shiftKey) {
          // go to end of tab content
          let focusableElements = $(".tab-pane.active").find('input:visible, select:visible, [tabindex="0"]:visible, [role="button"]:visible');
          focusableElements.get(focusableElements.length - 1).focus();
        } else {
          // go to start of tab content
          $(".tab-pane.active").find('input, select').get(0).focus();
        }
        break;
      case "ArrowLeft":
        // go to previous tab, cyclically
        e.preventDefault();
        if(e.target.previousSibling == null) {
          $(".overlay-panel-close").get(0).focus();
        } else if(!$(e.target.previousSibling).hasClass("nav-link")) {
          $("#overlay-tabs .nav-link").get($("#overlay-tabs .nav-link").length - 1).focus();
        } else {
          e.target.previousSibling.focus();
        }
        break;
      case "ArrowRight":
        // go to next tab, cyclically
        e.preventDefault();
        if(e.target.nextSibling == null) {
          $("#overlay-tabs .nav-link").get(0).focus();
        } else if(!$(e.target.nextSibling).hasClass("nav-link")) {
          $(".overlay-panel-close").get(0).focus();
        } else {
          e.target.nextSibling.focus();
        }
        break;
      case "Enter":
      case " ":
        e.preventDefault();
        e.target.click();
        break;
      default:
        return;
    }
  });

  // if user shift tabs back up to tabbar, focus on active tab
  $(".overlay-panel-close").on("focusin", function(e) {
    if(!$(e.relatedTarget).hasClass("nav-link")) {
      $('#overlay-tabs .active').focus();
    }
  });

  // close tab panel if user hits esc
  $('body').on("keydown", function(e) {
    if($('.overlay-panel.from-right').hasClass('is-visible') && e.key == "Escape") {
      e.preventDefault();
      $(".overlay-panel-close").get(0).click();
    }
  });

  // focus on edit graph button when user closes edit panel
  $(".overlay-panel-close").on("click", function(e) {
    $('#edit-graph-button').focus();
  });
});

$(document).ready(function() {
  hideShowMoreButton();

  $('.recent-obs-link-container').on('keydown', function(e){
    let toggleButton =  $(this).find('[data-toggle="popover"]')

    if(e.which === 32 || e.which === 13 || e.which === 27){
      e.preventDefault();
      toggleButton.popover('toggle');
      setTimeout(function(){
        $('#viewall-button').focus();
      }, 100)
    }
  })

  $('#viewall-button').on('keydown', function(e){
    if(e.which === 32 || e.which === 13){
      window.open($(this).attr('href'), '_blank');
    }
  })

  $('#zoom-1yr, #zoom-5yr, #zoom-10yr, #zoom-all, #favorite-star').on('keypress', function(e){
    if (e.key === " " || e.code === "Space" || e.keyCode === 32) {
      e.preventDefault();
    }

    if(e.keyCode === 13 || e.keyCode === 32) {
      this.click();
    }
  });

$('body').on('focus', '.overlay-panel-container * .panel-heading', function() {
  $(this).attr('tabindex', -1);
});

// 508 fix for Format Panel

seriesCountMax = 12;
  
$('body').on('keydown', '#log-scale-left', function(e) {
  if(e.which == 9) { 
    if (e.shiftKey) {
      $('.show-recession-bars').focus();
      e.preventDefault();
    } else {
      e.preventDefault();
      if($('#log-scale-right').parent().hasClass('hide')){
        e.preventDefault();
        $('.settings-graph-color').focus();
      }
      else{
        e.preventDefault();
        $('#log-scale-right').focus();
      }
   }
 }  
});

$('body').on('keydown', '#log-scale-right', function(e) {
  if(e.which == 9) { 
    e.preventDefault();
    $('.settings-graph-color').focus();
   }
 });

$('body').on('keydown', '.settings-graph-color', function(e) {
  if(e.which == 9) { 
    if (e.shiftKey) {
      if($('#log-scale-right').parent().hasClass('hide')){
        e.preventDefault();
        $('#log-scale-left').focus();
      } else {
        e.preventDefault();
        $('#log-scale-right').focus();
      }
      $('#log-scale-left').focus();
      e.preventDefault();
    } else {
      e.preventDefault();
      $('.settings-plot-color').focus();
    }

  }

  if (e.which == 13) {
    e.preventDefault();
    $('.settings-graph-color').click();
  }
});

$('body').on('keydown', '.settings-plot-color', function(e) {
  if(e.which == 9) { 
    if (e.shiftKey) {
      $('.settings-graph-color').focus();
      e.preventDefault();
    } else {
      e.preventDefault();
      $('.settings-text-color').focus();
    }

  }
  if (e.which == 13) {
    e.preventDefault();
    $('.settings-text-color').click();
  }


});

$('body').on('keydown', '.settings-text-color', function(e) {
  if(e.which == 9) { 
    if (e.shiftKey) {

      $('.settings-plot-color').focus();
      e.preventDefault();
    } 
  }
  if (e.which == 13) {
    e.preventDefault();
    $('.settings-text-color').click();
  }

});

$('body').on('click', '#add-series-button', function(e) {
  seriesCount = $('.line-style-container').length + 1;
  removeAndApplyLineStyleKeydown(seriesCountMax, seriesCount);
});

$('body').on('keydown', '#add-series-button', function(e) {
  if(e.key == " " || e.key == "Enter") {
    seriesCount = $('.line-style-container').length + 1;
    removeAndApplyLineStyleKeydown(seriesCountMax, seriesCount);

  }
});

$('body').on('click', '#edit-graph-button', function(e) {
  removeAndApplyLineStyleKeydown($('.line-style-container').length, $('.line-style-container').length);
  $('#overlay-tabs .active').focus();
});

$('body').on('keydown', '#edit-graph-button', function(e) {
  if(e.key == " " || e.key == "Enter") {
    removeAndApplyLineStyleKeydown($('.line-style-container').length, $('.line-style-container').length);
  }
});

function removeAndApplyLineStyleKeydown(maxLines, seriesCount) {
  for(i = 1; i <= maxLines; i++ ) {
    $('body').off('keydown', '#line-style-container-' + i);
    $('body').off('keydown', '.scale-left-' + i);
    $('body').off('keydown', '.scale-right-' + i);
    $('body').off('keydown', '.scale-bottom-' + i);
  }

  for(i = 1; i <= maxLines; i++ ) {
    let v = i;
    $('body').on('keydown', '#line-style-container-' + v, function(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        $('#line-style-container-' + v).get(0).click();
      }
    });
  }

  $('body').on('keydown', '#line-style-container-' + seriesCount, function(e) {
    if (e.keyCode == 9) {
      if(!e.shiftKey) {
        e.preventDefault();
        if($('#line-style-container-' + seriesCount).attr('aria-expanded') == 'false') {
          $('#overlay-tabs .active').focus();
        } else {
          $('.dash-style').focus()
        }
      }
    }
  });

  $('body').on('keydown', '.scale-left-' + seriesCount, function(e) {
    if (e.keyCode == 9) {
      if(!e.shiftKey) {
        e.preventDefault();
        if($('.scale-right-' + seriesCount).hasClass('disabled')) {
          $('.scale-bottom-' + seriesCount).focus();
        } else {
          $('.scale-right-' + seriesCount).focus();
        }
      }
    }
  });

  $('body').on('keydown', '.scale-right-' + seriesCount, function(e) {
    if (e.keyCode == 9) {
      if(!e.shiftKey) {
        e.preventDefault();
        $('#overlay-tabs .active').focus();
      }
    }
  });

  $('body').on('keydown', '.scale-bottom-' + seriesCount, function(e) {
    if (e.keyCode == 9) {
      if(!e.shiftKey) {
        e.preventDefault();
        $('#overlay-tabs .active').focus();
      }
    }
  });
}
// End of Format Panel Tab order

  //Add account tools to tab order
  $("a#save-graph-modal-btn, a#save-map-modal-btn, a#add-to-dashboard-modal-btn, a#emailnotify, #zoom-1yr, #zoom-5yr, #zoom-10yr, #zoom-all").attr("tabindex", "0").addClass('dropdown-btn-focus');
  $("#input-coed, #input-cosd").attr("tabindex", "0");

  window.graphResizedByUser = false;
  this.isMap = false;
  if ($('#resizable-graph-container').width() != $('#main-content-column').width()) {
    window.graphResizedByUser = true;
  }

  $(window).on('resize', function(){
      var containerWidth = $('#main-content-column').width();
      setGraphSize(containerWidth, $('#height').val());
  });

  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    if ($(this).data('target') == '#addseries') {
      $('#add-series-container').find('.add-data-series-input').focus();
    }
  });


  $('.edit-series-dropdown > a').on('click', function(e) {
    if ($('.series-group-tab').length <= 1)
      $('.fg-edit-series-tab').eq(0).trigger('click');
  });

  $('#tabbed-menu li > a[href^="#"]').on('click', function (e) {
    e.preventDefault();
    $(document).off("scroll");

    $('#tabbed-menu li').each(function () {
      $(this).removeClass('active');
    })
    $(this).parent().addClass('active');

    var target = this.hash,
      menu = target;
    $target = $(target);
    $('html, body').stop().animate({
      'scrollTop': $target.offset().top+2
    }, 500, 'swing', function () {
      window.location.hash = target;
    });
  });


  var offset = 300,
    scroll_top_duration = 700,
    $back_to_top = $('.back-top');

  $(window).on('scroll', function(){
    ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('back-is-visible') : $back_to_top.removeClass('back-is-visible back-fade-out');
  });

  $back_to_top.on('click', function(event){
    event.preventDefault();
    $('body,html').animate({
        scrollTop: 0 ,
      }, scroll_top_duration
    );
  });

  if (!!document.querySelector('.meta-col #recent-obs-link')) {
    new bootstrap.Popover(document.querySelector('.meta-col #recent-obs-link'), {
      container: '.meta-col .recent-obs-link-container',
      placement: "bottom",
      html: true,
      content: document.querySelector('#recent-obs-table')
    });
  }

  if (!!document.querySelector('#mobile-meta-col #recent-obs-link')) {
    new bootstrap.Popover(document.querySelector('#mobile-meta-col #recent-obs-link'), {
      container: '#mobile-meta-col .recent-obs-link-container',
      placement: "bottom",
      html: true,
      content: document.querySelector('#recent-obs-table')
    });
  }

  $("#fullscreen-btn").on("click", function (e) {
    toggleFullscreen();
  });

  $("#fullscreen-btn").on("keypress", function (e) {
    toggleFullscreen();
  });

  $("#fullscreen-btn-508").on("click", function (e) {
    toggleFullscreen508();
  });

  $("#fullscreen-btn-508").on("keypress", function (e) {
    toggleFullscreen508();
  });
  var main_col = $("#main-content-column, .alfred-graph-container"),
    col_width = main_col.width(),
    height = 450;

  if (col_width <= 640) {
    height = col_width * 0.75;
  }

  $('#resizable-graph-container').css({
    'width': col_width + 'px',
  });

  $('#graph-container').css({
    'width': col_width + 'px',
    'height': height + 'px'
  });

  $('#width').val(col_width).data('original-width', col_width);
  $('#height').val(height).data('original-height', height);

  document.onkeydown = function(e) {
    if(e.key == "Escape" && $('#fullscreen-container').hasClass('chart-modal')) {
      $('#fullscreen-btn-508').html("Fullscreen <i class=\"fas fa-expand fullscreen-btn-508-icon\"></i>");
      closeFullscreen();
    }
  };

  function toggleFullscreen()
  {
    if  ($('#fullscreen-container').hasClass('chart-modal')) {
      closeFullscreen();
    }
    else {
      openFullscreen();
    }
  }
  
  function toggleFullscreen508()
  {
    if  ($('#fullscreen-container').hasClass('chart-modal')) {
      closeFullscreen508();
    }
    else {
      openFullscreen508();
    }
  }

  function openFullscreen()
  {
    var gHeightModifier = 20;
    if($( ".edit-map-btn-large" ).parent().hasClass('hide') === false) {
      gHeightModifier = 30;
    }
    $('#fullscreen-container').toggleClass('chart-modal');
    $("#fullscreen-btn").html('<i class="fas fa-compress fullscreen-btn-icon"></i>');
    var gwidth = $('#fullscreen-container').width();
    var gheight = $('#fullscreen-container').height();
    setGraphSize(gwidth,gheight-gHeightModifier,true);
    $('#header').css('z-index','1');

  }

  function closeFullscreen()
  {
    $("#fullscreen-btn").html('<i class="fas fa-expand fullscreen-btn-icon"></i>');
    $('#fullscreen-container').toggleClass('chart-modal');
    setGraphSize($('#zoom-and-share').width(),450,true);
  }

  function openFullscreen508()
  {
    var gHeightModifier = 20;
    if($( ".edit-map-btn-large" ).parent().hasClass('hide') === false) {
      gHeightModifier = 50;
    }
    $('#fullscreen-btn-508').css('margin-right', '24px');
    $('#fullscreen-container').toggleClass('chart-modal');
    $("#fullscreen-btn-508").html('Back <i class="fas fa-compress fullscreen-btn-508-icon"></i>');
    var gwidth = $('#fullscreen-container').width();
    var gheight = $('#fullscreen-container').height();
    setGraphSize(gwidth,gheight-gHeightModifier,true);
    $('#header').css('z-index','1');
  }
  
  function closeFullscreen508()
  {
    $('#fullscreen-btn-508').css('margin-right', '');
    $('#fullscreen-container').toggleClass('chart-modal');
    $("#fullscreen-btn-508").html('Fullscreen <i class="fas fa-expand fullscreen-btn-508-icon"></i>');
    setGraphSize($('#zoom-and-share').width(),450,true);
  }

  function setGraphSize(graphWidth,graphHeight,oc){
    $('#resizable-graph-container').css({
      'width': graphWidth + 'px',
    });
    window.fredgraph.setGraphSize(graphWidth,graphHeight);
  }

  $('#graph-link-update-radio').on('click', function() {
    $('#graph-link-update-radio').prop("checked", true);
    $('#graph-link-static-radio').prop("checked", false);
    $('#graph-link-range-radio').prop("checked", false);
    
    if(isMap == true) {
      window.fredgraph.runCallbackOnFgmap(function(jsonObject) {
        var parsedobj = JSON.parse(jsonObject);
          parsedobj.isMap = window.isMap.toString();
          delete window.mapState;
          window.mapState = cleanMapState(parsedobj);
       });
     }

      window.fredgraph.appMiddleware(function(jsonObject) {
        var parsedobj = JSON.parse(jsonObject);
        parsedobj.isMap = window.isMap.toString();
          if(isMap == true) {
            window.mapState.mapDate = '9999-12-31';
            parsedobj = setMapSettingsSavedMap(parsedobj, window.mapState);
          }

          jsonObject = JSON.stringify(parsedobj);
        postToApi(jsonObject,"hash/?type=updating", function(response) {
          setGraphLinks(response.hash);
        })
      });
    

  });
  $('#graph-link-static-radio').on('click', function() {
    $('#graph-link-update-radio').prop("checked", false);
    $('#graph-link-static-radio').prop("checked", true);
    $('#graph-link-range-radio').prop("checked", false);
    
    if(isMap == true) {
      window.fredgraph.runCallbackOnFgmap(function(jsonObject) {
        var parsedobj = JSON.parse(jsonObject);
          parsedobj.isMap = window.isMap.toString();
          delete window.mapState;
          window.mapState = cleanMapState(parsedobj);
       });
     }

      window.fredgraph.appMiddleware(function(jsonObject) {
        var parsedobj = JSON.parse(jsonObject);
        parsedobj.isMap = window.isMap.toString();
          if(isMap == true) {
            parsedobj = setMapSettingsSavedMap(parsedobj, window.mapState);
          }
    
      jsonObject = JSON.stringify(parsedobj);
      postToApi(jsonObject,"hash/?type=static", function(response) {
        setGraphLinks(response.hash);
      })
    });
  });
  $('#graph-link-range-radio').on('click', function() {
    $('#graph-link-update-radio').prop("checked", false);
    $('#graph-link-static-radio').prop("checked", false);
    $('#graph-link-range-radio').prop("checked", true);
    if(isMap == true) {
      window.fredgraph.runCallbackOnFgmap(function(jsonObject) {
        var parsedobj = JSON.parse(jsonObject);
          parsedobj.isMap = window.isMap.toString();
          delete window.mapState;
          window.mapState = cleanMapState(parsedobj);
       });
     }
     
     window.fredgraph.appMiddleware(function(jsonObject) {
       var parsedobj = JSON.parse(jsonObject);
       parsedobj.isMap = window.isMap.toString();
         if(isMap == true) {
           parsedobj = setMapSettingsSavedMap(parsedobj, window.mapState);
         }
   
     jsonObject = JSON.stringify(parsedobj);
          postToApi(jsonObject,"hash/?type=range&data_range="+$('#graph-link-range-radio').attr('data-range'), function(response) {
            setGraphLinks(response.hash);
          })
        });
  });
  
  $('.permalink-btn').on('click', function(e) {
    e.preventDefault();
    $('#permalink-modal').modal('show');
    $('.embed-code-container, .page-permalink-container, .image-permalink-container, #graph-radios').hide();
    $('#embed-container-responsive').addClass('hidden');
    $('#permalink-modal-header').html($(this).text());
    var container = $(this).data("target");
    $(container).show();

    $('#graph-link-update-radio').prop("checked", true);
    $('#graph-link-static-radio').prop("checked", false);
    $('#graph-link-range-radio').prop("checked", false);
    
    if(isMap == true) {
      window.fredgraph.runCallbackOnFgmap(function(jsonObject) {
        var parsedobj = JSON.parse(jsonObject);
          parsedobj.isMap = window.isMap.toString();
          window.mapState = cleanMapState(parsedobj);
       });
     }
     

    window.fredgraph.appMiddleware(function(jsonObject) {

      //Add map to structure for passing for date
      var parsedobj = JSON.parse(jsonObject);
      //Set dates in obj sent to backend with correct value

      parsedobj.isMap = window.isMap.toString();
      if(isMap == true) {
        parsedobj = setMapSettingsSavedMap(parsedobj, window.mapState);
      }
      jsonObject = JSON.stringify(parsedobj);
      
      postToApi(jsonObject,"range/", function(response) {
        $('#graph-radios').show();
        $('#graph-link-static').show();
        $('#graph-link-static-radio').show();
        if (response.range) {
          var data = response.range;
          $('#graph-link-update').text(data.fixed_cosd);
          $('#graph-link-static').text(data.fixed_cosd_fixed_coed);
          $('#graph-link-range').text(data.floating_date_range);
          $('#graph-link-range-radio').attr('data-range', data.range);
          $('#graph-radios').show();
          if (typeof data.alfred_modal_text !== 'undefined' && data.alfred_modal_text.length > 0) {
            $('#modal-heading').text(data.alfred_modal_text);
            $('#graph-radios').hide();
            $( "#graph-link-static-radio" ).trigger( "click" );
          }
          else if (data.chart_type === 'pie' ){
            $('#graph-link-static').hide();
            $('#graph-link-static-radio').hide();
            $( "#graph-link-update-radio" ).trigger( "click" );
           }
          else if (this.isMap)  {    
            $('#graph-link-static').hide();
            $('#graph-link-static-radio').hide();
            $( "#graph-link-update-radio" ).trigger( "click" );
            if ( data.fixed_cosd === '') {
                $('#graph-radios').hide();
                $("#graph-link-static-radio" ).trigger( "click" );
            }
          } 
          else if ( data.fixed_cosd.length > 0)  {
            $( "#graph-link-update-radio" ).trigger( "click" );
          }     
          else {
            $('#graph-radios').hide();
            $( "#graph-link-static-radio" ).trigger( "click" );
          }

        }});
    });

  });
  $('.social-share-link').on('click', function(e) {
    e.preventDefault();
    var type = $(this).data( "shareType" );
    window.fredgraph.appMiddleware(function(jsonObject) {
      postToApi(jsonObject,"settings/url/", function(response) {
        if (response.url) {
          window.location = getApiHost()+'/graph/share.php?share='+type+'&' + response.url;
        }
      })
    });
  })

  $('#collapse-embed-responsive').on('click', function(e) {
    e.preventDefault();
    $('.embed-container-responsive').removeClass('hidden');

  });

  var clipboard = new ClipboardJS('.copy-to-clipboard');
  clipboard.on('success', function(e) {
    $(e.trigger).prev('input').blur().effect('highlight');
  });
  $('.embed-code-btn, .page-permalink-btn, .image-permalink-btn').on('click', function(e) {
    e.preventDefault();
  });

  $('a[data-bs-toggle="tab"]').on('show.bs.tab', function (e) {
    if($(e.target).attr('href') == '#save-share') {
      $('.embed-code-container, .page-permalink-container, .image-permalink-container, #graph-radios').hide();
    }
  });

  function setGraphLinks(hash){
    var baseUrl = getApiHost()+'/graph/';
    var image = (window.location.href.match('alfred'))
      ? 'alfredgraph.png'
      : 'fredgraph.png';
    if(this.isMap == false){
      $('#link-code').val(baseUrl + '?g='+hash);
      $('#image-code').val(baseUrl + image + '?g='+hash + '&height=490');
    } else {
      $('#link-code').val(baseUrl + '?m='+hash);
    }

    var embedWidth = parseInt($('#width').val()),
      embedHeight = parseInt($('#height').val());

    if (!window.graphResizedByUser) {
      embedWidth = 670;
      embedHeight = 475;
    }
    embedLinkHash = 'graph-landing.php?g=';

    if(this.isMap == true) {
      embedLinkHash = 'graph-landing.php?m=';
      embedHeight = embedHeight + 165;
    }
    var embedCode = '<iframe src="'+baseUrl+embedLinkHash+hash;
    embedCode += '&width='+embedWidth+'&height='+embedHeight+'" scrolling="no" frameborder="0" ';
    embedCode += 'style="overflow:hidden; width:'+embedWidth+'px; height:'+(embedHeight+50)+'px;" ';
    embedCode += 'allowTransparency="true" loading="lazy"></iframe>';
    $('#embed-code').val(embedCode);

    var embedCodeResponsive = '<div class="embed-container"><iframe src="'+baseUrl+embedLinkHash+hash;
    embedCodeResponsive += '&width='+embedWidth+'&height='+embedHeight+'" scrolling="no" frameborder="0" ';
    embedCodeResponsive += 'style="overflow:hidden;" allowTransparency="true" loading="lazy">';
    embedCodeResponsive += '</iframe></div><script src="' + getApiHost() + '/assets/stlrch-fred/fred-graph-react/embed.min.js" type="text/javascript"></script>';
    $('#embed-code-responsive').val(embedCodeResponsive);
  }

  var lastPieDate = $('#input-pie-date').val();
  $('#input-pie-date').on('changeDate', function() {
    var pieDate = $('#input-pie-date').val();
    if (lastPieDate !== pieDate && pieDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
      lastPieDate = pieDate;
      window.fredgraph.updatePieChart(pieDate);
    }
  });

  // Get tooltips to setup
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  });

  //Open and focus menus on specified keyup (13 = enter, 40 = down arrow, 38 = up arrow, 32 = space)
  $('#share-links-btn').on('keyup', function(e){
    if (e.which === 13 || e.which === 40){
      $('#share-links-btn').blur();
      $('#share-links-menu').addClass('show');
      $('#share-links-menu li:first>a').focus();
    }if (e.which === 32){
      e.preventDefault();
      $('#share-links-btn').blur();
      $('#share-links-menu').addClass('show').css('margin-top', '32px');
      $('#share-links-menu li:first>a').focus();
      if($('#share-links-menu').hasClass('show')){
        $('#share-links-menu > li > a').on('keyup', function(e){
          if(e.which === 13 || e.which === 32){
            $('#share-links-menu').removeClass('show')
          }
        })
        $('#share-links-menu > li > a').on('keydown', function(e){
          if(e.which === 9 && !e.shiftKey){
            if (!$(this).parent().next('li:not(:has(a.hide))').length) {
              $('#share-links-menu').removeClass('show')
            }
          }
        })
        $('#page-short-url').on('keydown', function(e){
          if( e.shiftKey && e.which === 9){
            $('#share-links-menu').removeClass('show')
          }
        })
      }
      }else if(e.which === 38) {
      $('#share-links-menu').find('li:not(:has(a.hide))').last().find('a').focus();
    }
  })

  $('#user-save-links-btn').on('keyup', function(e){
    if (e.which === 13 || e.which === 40){
      e.preventDefault();
      $('#user-save-links-btn').blur();
      $('#account-tools-menu').addClass('show');
      $('#account-tools-menu').find('li:not(.d-none)').first().find('a').focus();
    }if (e.which === 32){
      e.preventDefault();
      $('#user-save-links-btn').blur();
      $('#account-tools-menu').addClass('show').css('margin-top', '32px');
      $('#account-tools-menu').find('li:not(.d-none)').first().find('a').focus();
      if($('#account-tools-menu').hasClass('show')){
        $('#account-tools-menu > li > a').on('keyup', function(e){
          if(e.which === 13 || e.which === 32){
            e.preventDefault();
            $('#account-tools-menu').removeClass('show')
          }
        })
        $('#emailnotify').on('keydown', function(e){
          if(e.which === 9 && !e.shiftKey){
            $('#account-tools-menu').removeClass('show')
          }
        })
        $('#save-map-modal-btn').on('keydown', function(e){
          if(e.which === 9){
            $('#account-tools-menu').removeClass('show')
          }
        })
      }
    }else if(e.which === 38){
      $('#account-tools-menu').find('li:not(.d-none)').last().find('a').focus();
    }
  })
//  End open and focus on keyup

//Arrow key cycling thru menus
  $('#share-links-menu>li>a').on('keyup', function(e){
    if (e.keyCode === 40) {
      // if no next li not hide
      if (!$(this).parent().next('li:not(:has(a.hide))').length) {
        $('#share-links-menu li:first>a').focus();
      } else {
        $(this).parent().next().find('a').focus();
      }
    }else if(e.keyCode === 38){
      if (!$(this).parent().prev('li:not(:has(a.hide))').length) {
        $('#share-links-menu').find('li:not(:has(a.hide))').last().find('a').focus();
      } else {
        $(this).parent().prev().find('a').focus();
      }
    }
  })

  $('#account-tools-menu>li>a').on('keyup', function(e){
    if (e.keyCode === 40) {
      if (!$(this).parent().next('li:not(.d-none)').length) {
        $('#account-tools-menu').find('li:not(.d-none)').first().find('a').focus();
      } else {
        $(this).parent().next().find('a').focus();
      }
    }else if(e.keyCode === 38){
      if (!$(this).parent().prev('li:not(.d-none)').length) {
        $('#account-tools-menu').find('li:not(.d-none)').last().find('a').focus();
      } else {
        $(this).parent().prev().find('a').focus();
      }
    }
  })

  $('#save-map-modal-btn, #save-graph-modal-btn, #page-short-url').on('keydown', function(e){
    if(e.which === 9 && e.shiftKey){
      $('#account-tools-menu').removeClass('show');
      $('#share-links-menu').removeClass('show');
    }
  })

  $('#copy-link-code, #copy-embed-code, #copy-embed-code-responsive, #copy-image-code').on('keyup', function(e){
    if(e.keyCode === 13 || e.keyCode === 32){
      e.preventDefault();
      $(this).click();
    }
  })

  $('.account-dropdown>ul>li>a').on('keydown', function(e){

    if(e.keyCode === 13 || e.keyCode === 32){
      $('#account-tools-menu').removeClass("show");
    }
  })

  /*Focus modal header for screen reader*/
  $(".share-link-item, #save-map-modal-btn").on('click', function(e){
    let header = $('.modal-header-blue').find('h5')
    let title = $(header).html();
    setTimeout(function(){
    $(header).attr('aria-label', title).focus();
    }, 500);

  })

  var observer = new MutationObserver(function(mutations) {
    updateViewMapButton();
  });

  observer.observe(document.querySelector("#desktop-view-chart-button-container"), {
      childList: true
  });

  /*on edit map click, set color picker boxes to focusable
  * focus the header so screen reader tells user where they are
  * fire the edit map tabbing function
  * */
  $('#edit-map-button').on('click', function(){
    $('.clr-field').each(function(i, obj) {
      obj.style.cssText = 'color: '+obj.children[1].value;
    });
    $('.clr-field button').attr('tabindex', '0').addClass('focus-508');
    $('.edit-map-section').attr('tabindex', '0').focus().on('keydown', function(e){
      if(e.which == 9){
        $(this).attr('tabindex', '-1');
      }
    });
    mapPanelTabbing()
  })

  //set tabbing through edit map panel
  function mapPanelTabbing (){
    function getLastColorPickerIndex(){
        return $('.settings-color-checkbox').length -1;
    }

    $('#map-panel-close-button').on('keydown', function(e){
      $('.clr-field button').attr('tabindex', '0').addClass('focus-508');
      if(e.which === 9 && e.shiftKey){
        e.preventDefault();
        if($('.apply-interval-btn').length == 1){
          $('.apply-interval-btn').focus();
        }else{
          e.preventDefault()
          $(`#settings-color-checkbox-${getLastColorPickerIndex()} > div button`).focus();
        }
      }

      $('.apply-interval-btn').on('keydown', function(e){
        if(e.which == 9 && !e.shiftKey){
          e.preventDefault();
          $('#map-panel-close-button').focus()
        }
      })
      $('.clr-field').on('keydown', function(e){
        $(`#settings-color-checkbox-${getLastColorPickerIndex()} > div button`).on('keydown', function(e){
          if(e.which == 9 && !e.shiftKey){
            if(!$('.apply-interval-btn').length){
              e.preventDefault();
              $('#map-panel-close-button').focus();
            }
          }
        });
      })
    })
  }
// end document.ready
});

function unsetMapChart() {
  $("#share-socialmedia").removeClass("hide");
  $("#meta-twitter-button-sm").removeClass("hide");
  $("#zoom-and-share").css('background-color', 'rgb(225, 233, 240)');
  $("#fullscreen-btn").removeClass("fullscreen-map-btn");
  $("#map-date-container").addClass("hide");
  $(".image-permalink-btn").removeClass("hide");
  $("#favorite-toggle-container").removeClass("hide");
  $("#favorite-star").attr("tabindex","0");
  $(".account-dropdown-map").addClass("d-none");
  $(".account-dropdown-graph").removeClass("d-none");

  this.isMap = false;
  swapShareGtmTags(this.isMap);
}

function setDateChart(){
  $(".ranges").removeClass("hide");
  $("#input-cosd").removeClass("hide");
  $("#input-coed").removeClass("hide");
  $(".date-seperator").removeClass("hide");
  $("#zoom-pie").addClass("hide");
  unsetMapChart();
  this.isMap = false;
}
window.setDateChart = setDateChart;

function setNonDateChart(minDate, maxDate, currentDate, frequency){
  $(".ranges").addClass("hide");
  $("#input-cosd").addClass("hide");
  $("#input-coed").addClass("hide");
  $(".date-seperator").addClass("hide");
  $("#zoom-pie").removeClass("hide");
  initPieDatePicker(minDate,maxDate,frequency);
  if ($('#input-pie-date').val() !== currentDate) {
    $('#input-pie-date').val(currentDate);
  }
  this.isMap = false;
  unsetMapChart();
}
window.setNonDateChart = setNonDateChart;

function setMapChart() {
  $(".ranges").addClass("hide");
  $("#input-cosd").addClass("hide");
  $("#input-coed").addClass("hide");
  $(".date-seperator").addClass("hide");
  $("#zoom-pie").addClass("hide");
  $("#meta-twitter-button-sm").addClass("hide");
  $("#share-socialmedia").addClass("hide");
  $("#zoom-and-share").css('background-color', '#ffffff');
  $("#fullscreen-btn").addClass("fullscreen-map-btn");
  $("#map-date-container").removeClass("hide");
  $(".image-permalink-btn").addClass("hide");
  $("#favorite-toggle-container").addClass("hide");
  $(".account-dropdown-graph").addClass("d-none");
  $(".account-dropdown-map").removeClass("d-none");
  $("#share-links-btn").html('Share Map <i class="fa fa-share-square fg-share-links-btn-gtm"></i>'); 
  $("#page-short-url").html('<i class="fa fa-link bigger"></i> Custom Map Link');
  this.isMap = true;
  swapShareGtmTags(this.isMap);
}
window.setMapChart=setMapChart;

function swapShareGtmTags(swapingToMap) {
  if (swapingToMap) {
    $("#collapse-embed-responsive").addClass("hide");
    $("#fredhelp-embed").addClass("hide");
    $('.fg-chart-page-permalink-gtm').addClass('fg-map-page-permalink-gtm');
    $('.fg-map-page-permalink-gtm').removeClass('fg-chart-page-permalink-gtm');
    $('.fg-chart-page-embed-code-btn-gtm').addClass('fg-map-page-embed-code-btn-gtm');
    $('.fg-map-page-embed-code-btn-gtm').removeClass('fg-chart-page-embed-code-btn-gtm');
    $('.fg-chart-image-permalink-gtm').addClass('fg-map-image-permalink-gtm');
    $('.fg-map-image-permalink-gtm').removeClass('fg-chart-image-permalink-gtm');

    $('.fg-chart-embed-share-always-latest-gtm').addClass('fg-map-graph-embed-share-always-latest-gtm');
    $('.fg-map-graph-embed-share-always-latest-gtm').removeClass('fg-chart-embed-share-always-latest-gtm');
    $('.fg-chart-embed-share-range-gtm').addClass('fg-map-embed-share-range-gtm');
    $('.fg-map-embed-share-range-gtm').removeClass('fg-chart-embed-share-range-gtm')
    $('.fg-chart-embed-share-static-date-gtm').addClass('fg-map-embed-share-static-date-gtm');
    $('.fg-map-embed-share-static-date-gtm').removeClass('fg-chart-embed-share-static-date-gtm');

    $('#share-links-btn').addClass('fg-map-share-links-btn-gtm');
    $('#share-links-btn').removeClass('fg-chart-share-links-btn-gtm');
  } else {
    $("#collapse-embed-responsive").removeClass("hide");
    $("#fredhelp-embed").removeClass("hide");
    $('.fg-map-page-permalink-gtm').addClass('fg-chart-page-permalink-gtm');
    $('.fg-chart-page-permalink-gtm').removeClass('fg-map-page-permalink-gtm');
    $('.fg-map-page-embed-code-btn-gtm').addClass('fg-chart-page-embed-code-btn-gtm');
    $('.fg-chart-page-embed-code-btn-gtm').removeClass('fg-map-page-embed-code-btn-gtm');
    $('.fg-map-image-permalink-gtm').addClass('fg-chart-image-permalink-gtm');
    $('.fg-chart-image-permalink-gtm').removeClass('fg-map-image-permalink-gtm');

    $('.fg-map-graph-embed-share-always-latest-gtm').addClass('fg-chart-embed-share-always-latest-gtm');
    $('.fg-chart-embed-share-always-latest-gtm').removeClass('fg-map-graph-embed-share-always-latest-gtm');
    $('.fg-map-embed-share-range-gtm').addClass('fg-chart-embed-share-range-gtm')
    $('.fg-chart-embed-share-range-gtm').removeClass('fg-map-embed-share-range-gtm');
    $('.fg-map-embed-share-static-date-gtm').addClass('fg-chart-embed-share-static-date-gtm');
    $('.fg-chart-embed-share-static-date-gtm').removeClass('fg-map-embed-share-static-date-gtm');

    $("#share-links-btn").html('Share Graph <i class="fa fa-share-square fg-chart-share-links-btn-gtm"></i>');
    $("#page-short-url").html('<i class="fa fa-link bigger"></i> Custom Graph Link');
  }
}

function initPieDatePicker(startDate, endDate, frequency) {
  initializeFgDatePicker('#input-pie-date', frequency, startDate, endDate);
  if (startDate) {
    $('#input-pie-date').datepicker('setStartDate', startDate);
  }

  if (endDate) {
    $('#input-pie-date').datepicker('setEndDate', endDate);
  }
}

function formatPieDate(pickerInput){
  var pieDate = new Date(pickerInput.val().replace(/(\d\d\d\d)-(\d\d)-(\d\d)/, '$2/$3/$1'));
  pieDate = pieDate.getTime();
  return pieDate;
}

function updateViewMapButton() {
  let visible = $("#desktop-view-chart-button-container").children().length > 0;
  visible ? $("#desktop-view-chart-button-container").addClass("flex-grow-1") : $("#desktop-view-chart-button-container").removeClass("flex-grow-1");
}

function updatePageContent(seriesIds, hasTrend, fml)
{
  updateContentSection('title','series-title-text-container',seriesIds);

  if ((seriesIds.length > 1) || (hasTrend === true) || (fml === true)) {
    $("#meta-left-col").addClass("d-none invisible d-lg-flex");
  }
  else{
    $("#meta-left-col").removeClass("d-none invisible d-lg-flex");
  }
  updateBottomContent(seriesIds);
}
window.updatePageContent = updatePageContent;

function updateGraphTitle(jsonObject) {
  postToApi(jsonObject,"title/", function(response) {
    $( "#series-title-text-container" ).html( response.result );
  });
}
window.updateGraphTitle = updateGraphTitle;

function updateMetaContent(jsonObject) {
  // Don't update meta content using jQuery if map.
  // This is done in react.
  if (this.isMap === true) {
    return false;
  }
  // Avoid AJAX calls that do nothing.  Minimize network calls.
  if ((typeof jsonObject === 'undefined') || !jsonObject) {
    return false;
  }
  // Only update recent obs if 1 FRED graph series.
  var fgchart = JSON.parse(jsonObject);

  if (fgchart.chart.mode == "alfred" ) {
    if (fgchart.seriesObjects.length > 2 
      || Object.keys(fgchart.seriesObjects[0].series_objects).length !== 1
      || typeof fgchart === 'undefined'
      || typeof fgchart.seriesObjects === 'undefined') {
        return false;
      } 
  }
  else if (typeof fgchart === 'undefined'
      || typeof fgchart.seriesObjects === 'undefined'
      || fgchart.seriesObjects.length !== 1 
      || Object.keys(fgchart.seriesObjects[0].series_objects).length !== 1) {
    $(".add-data-list").addClass("hide");
    $(".add-data-list").removeClass('account-dropdown-graph');
    $("#email-notify-container").addClass("hide");
    $("#email-notify-container").removeClass('account-dropdown-graph');
    return false;
  } else {
    $(".add-data-list").removeClass("hide");
    $(".add-data-list").addClass('account-dropdown-graph');
    $("#email-notify-container").removeClass("hide");
    $("#email-notify-container").addClass('account-dropdown-graph');
  }

  postToApi(
    jsonObject,
    "metadata/",
    function(response) {
      $( "#meta-left-col").html( response.result );
      
      new bootstrap.Popover(document.querySelector('.meta-col #recent-obs-link'), {
        container: '.meta-col .recent-obs-link-container', placement: "bottom", html: true, content: document.querySelector('#recent-obs-table')
      });
      new bootstrap.Popover(document.querySelector('#mobile-meta-col #recent-obs-link'), {
        container: '#mobile-meta-col .recent-obs-link-container',
        placement: "bottom",
        html: true,
        content: document.querySelector('#recent-obs-table')
      });
      $("#meta-left-col").removeClass("d-none invisible d-lg-flex");
    },
    function() {
      $("#meta-left-col").addClass("d-none invisible d-lg-flex");
    }
  );
}
window.updateMetaContent = updateMetaContent;

function updateBottomContent(seriesIds){
  updateContentSection('notes','notes-content',seriesIds);
  updateContentSection('releasetables','releasetables-content',seriesIds);
  updateContentSection('relatedcontent','relatedcontent-content',seriesIds);
}

function updateContentSection(endpoint, element, seriesIds){
  var mode = getModeFromHost();
  var host = getApiHost();
  var baseUrl = host+"/graph/api/series/";
  var request = $.ajax({
    url: baseUrl+endpoint+"/"+seriesIds.join(),
    method: "GET",
    data: { id : seriesIds, mode: mode },
    dataType: "json"
  });
  request.done(function( response ) {
    if (response.result){
      $( "#"+element ).html( response.result );
      $( "#"+endpoint ).removeClass('hide');
    }
    //Only update copyright when updating notes
    if ( endpoint === 'notes') {
      if (response.result && response.result.match(/[Cc]opyright/)) {
        $(".copyright-indicator, .copyright-note").removeClass('hide');
      }
      else {
        $(".copyright-indicator, .copyright-note").addClass('hide');
      }
    } else if(endpoint === 'relatedcontent') {
      hideShowMoreButton();
    }
    $(".related-resource-img").each(function () {
      $(this).attr("src", $(this).data("src")).fadeIn();
    });
  });
  request.fail(function( jqXHR, textStatus ) {
    console.log( "Request failed: " + textStatus );
  });
}

function toggleTooltip(enabled){
  var displayValue =  (enabled === "no") ? "none" : "block";
  $('.highcharts-tooltip').css('display',displayValue);
}
window.toggleTooltip = toggleTooltip;

function checkCopyrighted(seriesIds){
  var mode = getModeFromHost();
  var host = getApiHost();
  var baseUrl = host+"/graph/api/series/";
  var request = $.ajax({
    url: baseUrl+"copyright/"+seriesIds.join(),
    method: "GET",
    data: { mode: mode },
    dataType: "json"
  });
  request.done(function( response ) {
      if (response.result == true) {
        $(".copyright-indicator, .copyright-note").removeClass('hide');
      }
      else {
        $(".copyright-indicator, .copyright-note").addClass('hide');
      }
  });
  request.fail(function( jqXHR, textStatus ) {
    console.log( "Request failed: " + textStatus );
  });
}
window.checkCopyrighted = checkCopyrighted;

function setDateInputs(jsonObject, cosd, coed) {
  return jsonObject;
}
window.setDateInputs = setDateInputs;

function handleDateChange(e) {
  $("#range").val("Custom");
  var cosd = $("input.cosd").val();
  var coed = $("input.coed").val();
  const regexDateFormat = /^\d{4}-\d{2}-\d{2}$/;
  if((cosd.match(regexDateFormat) === null) || (coed.match(regexDateFormat) === null)) {
    return;
  }
  window.fredgraph.validateExtremes(cosd, coed, function(
    jsonObject,
    cosd,
    coed
  ) {
    window.setDateInputs(jsonObject, cosd, coed);
  });
  window.fredgraph.setExtremesWithFormattedDate(
    $("input.cosd").val(),
    $("input.coed").val()
  );
}

/*** Calculate MinViewMode from Freq of graph ****/
function getMinViewModeFromFreq(frequency){
  var minViewMode = "days";
  if (/^Annual/.test(frequency) || /^5\sYear/.test(frequency)) {
    minViewMode = "years";
  } else if (
    /^Monthly/.test(frequency) ||
    /^Quarterly/.test(frequency) ||
    /^Semiannual/.test(frequency)
  ) {
    minViewMode = "months";
  }
  return minViewMode;
}
window.getMinViewModeFromFreq = getMinViewModeFromFreq;

function initializeFgDatePicker(selector, frequency, minDate, maxDate) {
  $(selector).datepicker({
    format: "yyyy-mm-dd",
    autoclose: true,
    forceParse: true,
    startView: "decade",
    minViewMode: getMinViewModeFromFreq(frequency),
    orientation: "bottom",
    zIndexOffset: 1901,
    startDate: minDate,
    endDate: maxDate
  });
}
window.initializeFgDatePicker = initializeFgDatePicker;

function initializeDatePicker(frequency, minDate, maxDate) {
  initializeFgDatePicker('.cosd', frequency, minDate, maxDate);
  initializeFgDatePicker('.coed', frequency, minDate, maxDate);
  $("input.cosd, input.coed").on("changeDate", handleDateChange);
  $("input.cosd, input.coed").on("keyup", handleDateChange);
}

function handleAfterSetExtremes(jsonObject, chartObject) {

  $("#zoom-controls").removeClass("hide");
  if (!$("#input-cosd").data("datepicker")) {
    initializeDatePicker(chartObject.chart.frequency, chartObject.chart.min_date, chartObject.chart.max_date);
  }
  var extremes = jsonObject.extremes;

  $("#input-cosd").data('datepicker')._process_options({minViewMode: getMinViewModeFromFreq(chartObject.chart.frequency)})
  $("#input-coed").data('datepicker')._process_options({minViewMode: getMinViewModeFromFreq(chartObject.chart.frequency)})

  $("#input-cosd").datepicker("setStartDate", extremes.dataStartDate);
  $("#input-cosd").datepicker("setEndDate", extremes.dataEndDate);
  $("#input-coed").datepicker("setStartDate", extremes.dataStartDate);
  $("#input-coed").datepicker("setEndDate", extremes.dataEndDate);
  $("#input-cosd").datepicker("update", extremes.startDate);
  $("#input-coed").datepicker("update", extremes.endDate);

}
window.handleAfterSetExtremes = handleAfterSetExtremes;

function postToApi(jsonObject,endpoint,callback, failCallback) {
  var formData = new FormData();
  formData.append('settings', jsonObject);
  var options = { data: formData };
  var host = getApiHost();
  var baseUrl = host+"/graph/api/series/";
  var request = $.ajax({
    beforeSend: function(xhrObj){
      xhrObj.setRequestHeader("Accept","application/json");
    },
    url: baseUrl+endpoint,
    method: "POST",
    data: jsonObject,
    contentType: "application/json;charset=utf-8",
    dataType: "json",
    processData: false
  });
  request.done(function( response ) {
    callback(response);
  });
  request.fail(function( jqXHR, textStatus ) {
    console.log( "Request failed: " + textStatus );
    if (failCallback !== undefined) {
      failCallback();
    }
  });
}

function runPowerPoint(e) {
    e.preventDefault();
    window.fredgraph.appMiddleware(function(jsonObject) {
      postToApi(jsonObject,"hash/", function(response) {
        if (response.hash) {
          exportPowerpoint({
              id: response.hash,
              title: ' ', // Use title in chart image
              notes: scrapeNotes()
          });
        }});
    });
    return false;
}
window.runPowerPoint = runPowerPoint;

function exportPowerpoint(options) {
  var bodyJson = {
    g: options.id,
    id: options.id,
    notes: options.notes
  }
  fetch(`/graph/api/ppt_download`, { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(bodyJson)})
  .then( response => {
    fileName = response.headers.get('X-filename');
    return response.blob() } 
  ).then( blob => {
    var fileURL = window.URL.createObjectURL(blob);
    //window.location.assign(fileURL); //this way can't add name to filename
    var filelink = document.createElement('a');
    document.body.appendChild(filelink);
    filelink.style.display = 'none';
    filelink.href = fileURL;
    filelink.download = fileName;
    filelink.click();
    window.URL.revokeObjectURL(fileURL);
    filelink.remove();
  });
}

function scrapeNotes() {
  var output = '', notes = [];

  $(".notes-series-group").each(function (x, seriesItem) {
      $(seriesItem).find('p').each(function(y, item) {
          if ($(item).hasClass("note-faq"))
              return true;

          str = $(item).text();
          notes.push($.trim(str));
      });
      // Newline placeholder = ' || '
      notes.push(' || ');
  });

  output = notes.length ? notes.join(' || ') : '';
  return output;
}
function adjustColorPicker(lineIndex){
  if (wentOffScreen($('#line-color-'+lineIndex))){
    $('#line-color-'+lineIndex+'-wrapper').css('position','absolute');
    $('#line-color-'+lineIndex+'-wrapper').css('bottom','350px');
  }
}

function cleanMapState(parsedobj){
  if (!parsedobj.mapFreqEndDate) {
    parsedobj.mapEndDate = parsedobj.mapMetaData.mapEndDate;
  }

  delete parsedobj.mapObs;
  delete parsedobj.mapColorAxis;
  delete parsedobj.mapFrequencyOptions;
  delete parsedobj.mapFrequencyAggOptions;
  delete parsedobj.mapMetaData;
  delete parsedobj.mapObsDate;
  delete parsedobj.mapObsDateFormatted;
  delete parsedobj.mapPlotOptions;
  delete parsedobj.mapTitle;
  delete parsedobj.mapUnitTransformationOptions;
  
  return parsedobj;
}
window.cleanMapState = cleanMapState;

function setMapSettingsSavedMap(chartSettings, mapSettings){
  //Need to set chart date so mapdate gets set with logic
  chartSettings.coed = mapSettings.mapDate;
  chartSettings.chart.coed = mapSettings.mapDate;
  chartSettings.seriesObjects[0].coed =  mapSettings.mapDate;

  let parsedobj = {
    ...chartSettings,
    ...mapSettings
  };

  return parsedobj;
}
window.setMapSettingsSavedMap = setMapSettingsSavedMap;

function wentOffScreen(element){
  var elementTop = $(element).offset().top;
  var elementBottom = (elementTop + $(element).outerHeight());
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return (elementBottom+300) > viewportBottom;
}

function getApiHost() {
  var host = (/alfred/).test(window.location.host)
    ? websiteCfg.alfred_host : websiteCfg.fred_host;
  host = host ? host : 'localhost:8080';

  return window.location.protocol + "//" + host;
}

function getModeFromHost()
{
  return ((/alfred/).test(window.location.host) ? 'alfred' : 'fred');
}

function hideShowMoreButton() {
  // move focus to first overflow element when Show more... is clicked via keyboard
  $(".see-more-content").on("keydown", function(e){
    if(e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      this.click();
      e.target.parentElement.parentElement.children[4].children[0].querySelector(".related-resource-title a").focus();
    }
  });

  // show additional images and hide related content 'see more' buttons after click
  $(".see-more-content").on("click", function(e){
    if(browserArray.includes(navigator.userAgent.split(' ').lastItem.split('/')[0])) {
      let lazyloadImages = document.querySelectorAll("div.more-trending-series-item img.lazy-load");
      lazyloadImages.forEach(async function(img) {
        $(img).attr("src",$(img).data("src")).fadeIn();
        img.classList.remove('lazy-load');
        // wait before loading the next image or server
        // will respond with 404s after too many requests
        await sleep(700);
      });

      $(e.target.parentElement).slideUp(350);
    }
  });
}

let yPosition = -1;
$('#share-links-btn').on("click", function() {
  yPosition = window.scrollY;
});

document.getElementById("permalink-modal-header").onfocus = function(e) {
  window.scrollTo(0,yPosition);
  $('#btn-close').focus();
};
